import userInfoPlugin from "./userInfo";

export default [userInfoPlugin];
